import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import dumbbell from "../../../assets/images/SVG/dumbbell.svg";
import * as routes from "../../../constants/routes";

const CardContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderRadius: "6px",
  padding: "20px",
  height: "100%",
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#ede3f5",
    border: `3px solid ${theme.palette.primary.main}`,
    padding: "17px",
  },
}));

const TextContent = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  flex: 1,
});

const Title = styled(Typography)({
  fontFamily: "Montserrat, sans-serif",
  fontWeight: 600,
  letterSpacing: "0.17px",
  color: "#333333",
});

const Description = styled(Typography)({
  color: "#666666",
});

const IconWrapper = styled(Box)({
  width: "60px",
  height: "60px",
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

const ArrowButton = styled(IconButton)({
  color: "#333333",
  padding: "4px",
  alignSelf: "flex-start",
});

const Badge = styled(Box)({
  display: "inline-flex",
  alignItems: "center",
  backgroundColor: "#EEE5F4",
  color: "#662D91",
  fontWeight: 600,
  borderRadius: "50px",
  marginInline: "12px",
});

const PersonalizedTrainingCard = ({ currentUser }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const hasTrainingPermission = currentUser?.tags?.length > 0;

  const handleClick = () => {
    if (hasTrainingPermission) {
      navigate(routes.R_TAKE_TEST_PLAN);
      return;
    }
    navigate(routes.R_TAKE_TEST);
  };

  return (
    <CardContainer
      onClick={handleClick}
      sx={{
        gap: { xs: "10px", sm: "16px" },
      }}
    >
      <IconWrapper>
        <Box component="img" src={dumbbell} alt="" width="60px" height="60px" />
      </IconWrapper>
      <TextContent>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Title
            sx={{
              fontSize: { xs: "12px", sm: "16px" },
              lineHeight: { xs: "13px", sm: "16px" },
            }}
          >
            {hasTrainingPermission
              ? t("global.training_ready_title")
              : t("global.personalized_training")}
          </Title>
          {!hasTrainingPermission && (
            <Badge
              sx={{
                fontSize: { xs: "10px", sm: "12px" },
                padding: { xs: "2px 4px", sm: "2px 10px" },
                textAlign: "center",
              }}
            >
              {t("global.play_3x_per_day")}
            </Badge>
          )}
        </Box>
        <Description
          sx={{
            fontSize: { xs: "11px", sm: "15px" },
          }}
        >
          {hasTrainingPermission
            ? t("global.training_ready_description")
            : t("global.take_test_discover_training")}
        </Description>
      </TextContent>
      <ArrowButton size="small">
        <ArrowForwardIcon fontSize="small" />
      </ArrowButton>
    </CardContainer>
  );
};

export default PersonalizedTrainingCard;
